import React from "react";
import { Tooltip } from "antd";
import { ThunderboltOutlined, CloudOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { DataScienceJobOrigin } from "../../api/DataScienceJobApi";

interface JobOriginIndicatorProps {
  origin: DataScienceJobOrigin;
  /** Icon size in px */
  size?: number;
  /** Override default origin tooltip */
  tooltipTitle?: string;
}

const JobOriginIndicator: React.FC<JobOriginIndicatorProps> = ({
  origin,
  size = 14,
  tooltipTitle,
}) => {
  const { t } = useTranslation();
  const title = tooltipTitle ?? t(`DataScienceJobs-Origin.${origin}`);
  const isApi = origin === "api" || origin === "api_ecs";
  const style: React.CSSProperties = {
    fontSize: size,
    color: isApi ? "#722ed1" : "#1890ff",
    cursor: "default",
  };

  return (
    <Tooltip title={title}>
      {isApi ? (
        <ThunderboltOutlined style={style} />
      ) : (
        <CloudOutlined style={style} />
      )}
    </Tooltip>
  );
};

export default JobOriginIndicator;
